import { camelcaseToUnderscore, objectMap } from 'javascripts/utils';

!function ($) {
    "use strict";

    var Components = function () { };

    //initializing slidebar
    Components.prototype.initSlidebar = function () {
        $('.slidebar-toggle').click(function() {
            $(this).parent('.slidebar').toggleClass('slidebar-enabled');
            $('.slidebar-overlay').toggleClass('show');
        });
        $('body').click(e => {
            if($(e.target).hasClass('slidebar-overlay')) $('.slidebar-toggle').click();
        });
    },

    //initializing tooltip
    Components.prototype.initTooltipPlugin = function () {
        $('[data-bs-toggle="tooltip"]').click(function() { $(this).tooltip('hide')});
        $.fn.tooltip && $('[data-bs-toggle="tooltip"]').tooltip({trigger: 'hover'})
    },

    //initializing popover
    Components.prototype.initPopoverPlugin = function () {
        $.fn.popover && $('[data-bs-toggle="popover"]').popover({trigger: 'click'})
    },

    //initializing dropdown
    Components.prototype.initDropdownPlugin = function () {
        $.fn.dropdown && $('[data-bs-toggle="dropdown"]').dropdown({trigger: 'focus'})
    },

    //nav-link active handler
    Components.prototype.initNavLinkStatus = function () {
        $(document).on('click', '.nav-link', function() {
            let url = $(this).attr('href') || $(this).attr('data-href');
            // account for sticky and non-sticky headers - they should stay in sync
            $(`[href='${url}'],[data-href='${url}']`).siblings('.nav-link').removeClass('active');
            $(`[href='${url}'],[data-href='${url}']`).addClass('active');
        });
        $('.navtabs-onhover .nav-item').hover(function() {
            var tab_id = $(this).find('.nav-link').attr('data-bs-target');
            $(this).siblings().find('.nav-link').removeClass('active');
            $(this).find('.nav-link').addClass('active');
            $(this).parent().parent().siblings().find('.tab-content .tab-pane').removeClass('active show');
            $(tab_id).addClass('active show');
        });
    },

    //initializing toast
    Components.prototype.initToastPlugin = function() {
        $.fn.toast && $('[data-bs-toggle="toast"]').toast()
    },

    //initializing form validation
    Components.prototype.initFormValidation = function () {
        $(".needs-validation").on('submit', function (event) {
            $(this).addClass('was-validated');
            if ($(this)[0].checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return true;
        });
    },

    //initializing expander
    Components.prototype.initCollapsible = function () {
        $(document).on('click', '.collapsible', function() {
            let {scrollToOnClose, scrollOffset} = this.dataset;
            if($(this).hasClass('open') && scrollToOnClose) {
                // handle offset for sticky header
                window.scrollTo({
                    behavior: 'instant',
                    top:
                        document.getElementById(scrollToOnClose).getBoundingClientRect().top -
                        document.body.getBoundingClientRect().top -
                        scrollOffset,
                })
            }
            $(this).toggleClass('open');
        });
    },

    //initializing sticky
    Components.prototype.initSticky = function () {
        $('.sticky').each(function() {
            let stickyElement = this;
            let stickAfter = $(stickyElement).data('stick-after');
            let scrollSpyTarget = $(stickyElement).data('scroll-spy-target');
            let scrollSpyEnabled = false;
            $(window).scroll(function() {
                if(window.scrollY > stickAfter) {
                    if(scrollSpyTarget && !scrollSpyEnabled) {
                        $('body').scrollspy({ target: scrollSpyTarget, offset: 170 });
                        scrollSpyEnabled = true;
                    }
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            // display sticky header on a delay to avoid a halt when top nav link was clicked
                          stickyElement.classList.add('stick');
                          window.dispatchEvent(new Event('gitb.topStick'));
                        }, 500);
                    });
                } else {
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            stickyElement.classList.remove('stick')
                        }, 500);
                    });
                }
            });
        })
    },

    //initializing custom modal
    Components.prototype.initCustomModalPlugin = function() {
        $('[data-plugin="custommodal"]').on('click', function(e) {
            e.preventDefault();
            var modal = new Custombox.modal({
                content: {
                    target: $(this).attr("href"),
                    effect: $(this).attr("data-animation")
                },
                overlay: {
                    color: $(this).attr("data-overlayColor")
                }
            });
            // Open
            modal.open();
        });
    },

    // passing & assigning custom data attributes to bs modal elements
    Components.prototype.initModalCustomData = function() {
        $('.modal').each(function() {
            this.addEventListener('show.bs.modal', function (e) {
                let dataset = e.relatedTarget?.dataset; // relatedTarget contains the element that triggered the modal
                if(dataset) {
                    objectMap(dataset, (v, k) => {
                        if(!k.startsWith('bs')) $(`#${camelcaseToUnderscore(k)}`).val(v); // ex: assign data-item-id to #item_id in the modal
                    });
                }
            });
        });
    },

    // Counterup
    Components.prototype.initCounterUp = function() {
        var delay = $(this).attr('data-delay')?$(this).attr('data-delay'):100; //default is 100
        var time = $(this).attr('data-time')?$(this).attr('data-time'):1200; //default is 1200
         $('[data-plugin="counterup"]').each(function() {
            $(this).counterUp({
                delay: delay,
                time: time
            });
         });
    },

    // initializing
    Components.prototype.init = function () {
        this.initSlidebar(),
        this.initTooltipPlugin(),
        this.initPopoverPlugin(),
        this.initDropdownPlugin(),
        this.initToastPlugin(),
        this.initFormValidation(),
        this.initCollapsible(),
        this.initSticky(),
        this.initCustomModalPlugin(),
        this.initModalCustomData(),
        this.initCounterUp(),
        this.initNavLinkStatus()
    },

    $.Components = new Components, $.Components.Constructor = Components

}(window.jQuery),
function ($) {
    "use strict";
    $.Components.init();
}(window.jQuery);
